






































import Vue from 'vue';
import { mixin as clickaway } from 'vue-clickaway';
import { Component, Watch } from 'vue-property-decorator';
import debounce from 'lodash/debounce';

import { ProductsState, ContextsState } from '@/store';
import { Product } from '@/dto';

@Component({ mixins: [clickaway] })
export default class Products extends Vue {
    public localFilter: string = '';
    public expanded: boolean = false;
    public filterProductsDebounced = debounce(this.filterProducts, 250);

    public get currentContextId(): string | undefined {
        return ContextsState.currentContextId;
    }
    public get productsList() {
        return ProductsState.list;
    }
    public get currentProduct() {
        return ProductsState.current;
    }
    public get isProductsLoading() {
        return ProductsState.isLoading;
    }

    @Watch('currentContextId')
    public onContextChanged() {
        if (this.localFilter.length) {
            this.clearProducts();
            this.selectProduct();
        }
    }

    @Watch('currentProduct')
    public onProductFilterChanged(value: Product) {
        this.selectProduct(value, true);
    }

    public clearProducts() {
        ProductsState.clearProducts();
    }

    public focusSearch() {
        (this.$refs.search as any).$el.focus();
    }

    public selectProduct(product?: Product, local: boolean = false) {
        this.localFilter = product ? product.name : '';

        if (!local) {
            ProductsState.selectProduct(product);
        }

        this.close();
    }

    public close() {
        this.localFilter = this.currentProduct ? this.currentProduct.name : '';
        this.expanded = false;
    }

    public filterProducts() {
        ProductsState.fetchProducts({
            contextId: ContextsState.currentContextId!,
            filter: this.localFilter,
            top: 4,
        });
    }
}
